export default __webpack_public_path__ + "a124a81d.woff";